import React, { useEffect, useState } from 'react';
import { Dimensions, View } from 'react-native';
import localforage from 'localforage';
import { Text } from '@/components/Text';
import { ConfirmDialog } from '@/components/ui/shared/Dialog';
import ConfettiCannon from 'react-native-confetti-cannon';
import { logError } from '@/utils/logHandling';
import { IS_WEB } from '@/utils/platform';
import { useStoreState } from '@/stores/store';
import constants, { isPatientApp } from '@/config/constants';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { styles } from '@/components/NewUIFeatureModal/styles';

export const NewUIFeatureModal: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [showConfetti, setShowConfetti] = useState<boolean>(false);
  const { width, height } = Dimensions.get('window');
  const { isTherapistDemo } = useStoreState((state) => state);

  useEffect(() => {
    const checkIfModalShown = async () => {
      try {
        const hasSeenInStorage = IS_WEB
          ? ((await localforage.getItem('hasSeenNewTemplateModal')) as string)
          : await AsyncStorage.getItem('hasSeenNewTemplateModal');
        const hasSeen = hasSeenInStorage ? JSON.parse(hasSeenInStorage) : false;

        if (!hasSeen) {
          if (IS_WEB) {
            await localforage.setItem('hasSeenNewTemplateModal', 'true');
          } else {
            await AsyncStorage.setItem('hasSeenNewTemplateModal', 'true');
          }
          setIsVisible(true);
          setTimeout(() => setShowConfetti(true), 500);
        }
      } catch (err) {
        logError('Error checking modal flag:', err);
      }
    };

    checkIfModalShown();
  }, []);

  if (isPatientApp || constants.appVersion !== '1.10.29' || isTherapistDemo) {
    return;
  }

  if (IS_WEB) {
    const currentUrlParams = new URLSearchParams(window.location.search);
    if (currentUrlParams.get('demoStarten') === 'true') {
      return;
    }
  }

  const handleClose = async () => {
    try {
      if (IS_WEB) {
        await localforage.setItem('hasSeenNewTemplateModal', 'true');
      } else {
        await AsyncStorage.setItem('hasSeenNewTemplateModal', 'true');
      }
    } catch (err) {
      logError('Error saving modal flag:', err);
    }
    setShowConfetti(false);
    setIsVisible(false);
  };

  return (
    <ConfirmDialog
      isVisible={isVisible}
      headerText="🎉 Die Bibliothek ist da!"
      confirmAction={handleClose}
    >
      <View style={styles.modalContent}>
        {showConfetti ? (
          <View
            pointerEvents="none"
            style={{
              position: 'absolute',
              top: -300,
              left: IS_WEB ? -(width * 0.22) : -180,
              width,
              height,
            }}
          >
            <ConfettiCannon
              count={200}
              origin={{ x: 0, y: 0 }}
              fadeOut
              autoStart
            />
          </View>
        ) : null}
        <View>
          <Text style={{ fontWeight: 'semibold' }}>
            Entdecken Sie über 50 sofort nutzbare Vorlagen für Übungssets.
            Speichern Sie außerdem Ihre eigenen Sets als Vorlagen und greifen
            Sie jederzeit wieder darauf zu. Weniger Aufwand - mehr Zeit für Ihre
            Patient:innen.
          </Text>
        </View>
      </View>
    </ConfirmDialog>
  );
};
